import React from 'react';
import * as i18next from 'i18next';
import { IConsentInfoAccount } from '../../types/IConsentInfoAccount';
import ConsentLegalInfo from '../consent/ConsentLegalInfo';

interface IProps {
  t: i18next.TFunction;
  accounts: IConsentInfoAccount[];
  bankName: string;
  replacementTokens: { [key: string]: any };
}

const ReconfirmationStageAccountPageContent: React.FC<IProps> = (props: IProps) => {
  const { t } = props;

  return (
    <div data-testid="reconfirmation-stage-account-page-content">
      <div className="mb-6">
        <h1
          className={` text-md md:text-lg text-primary-2  uppercase font-bold`}
          data-testid="consent_page_introduction_title"
        >
          {t<string>('Provide consent')}
        </h1>
      </div>
      <ConsentLegalInfo />
    </div>
  );
};

export default ReconfirmationStageAccountPageContent;
